import React, { forwardRef } from 'react';
import { Skeleton as MuiSkeleton } from '@mui/material';
import { isEmpty } from 'lodash';

import { reportErrorInProductionOrThrow } from '~/Utils';

/**
 This Component is a wrapper on MUI component.
 This component should be imported and not MUI directly!
**/
export interface SkeletonProps {
  /** The shape of the placeholder. */
  variant?: 'text' | 'rectangular';
  /** Width of the skeleton. */
  width?: number | string;
  /** Height of the skeleton. */
  height?: number | string;
  /** CSS class name applied to the root element. */
  className?: string;
}

const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(
  ({ variant, width, height, className, ...restProps }, ref) => {
    if (!isEmpty(restProps)) {
      reportErrorInProductionOrThrow(
        `Unexpected props passed to Skeleton: ${Object.keys(restProps).join(', ')}.
Examine if these need to be removed, or added explicitly to the SkeletonProps interface and to the component's signature.`,
        true
      );
    }

    return (
      <MuiSkeleton variant={variant} width={width} height={height} className={className} ref={ref} {...restProps} />
    );
  }
);

Skeleton.displayName = 'Skeleton';

export default Skeleton;
